import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import $ from "jquery";
import "./css/bootstrap.min.css";
import "./css/font-awesome.min.css";
import "./css/cover.css";
import "./css.css?family=Open+Sans:400,800,700,600,300";
import "./css/animate.css";
import "./css/lightslider.min.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
